"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signOut = void 0;
const signOut = async (authDomain, requestBody) => {
    const signOutUrl = `${authDomain}/api/signout`;
    const response = await fetch(signOutUrl, {
        method: "POST",
        body: JSON.stringify(requestBody),
    });
    if (!response.ok) {
        throw new Error("Sign out failed");
    }
};
exports.signOut = signOut;
